import { render, staticRenderFns } from "./WorkflowSociated.vue?vue&type=template&id=474dc4de"
import script from "./WorkflowSociated.vue?vue&type=script&lang=js"
export * from "./WorkflowSociated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports